import {
  LuUser2,
  FiMail,
  SlBookOpen,
  MdOutlineFormatItalic,
  GiMedicalDrip,
  LuClipboardList,
  AiOutlineSend,
  TbMailStar,
  FiArrowRight,
  FiUser,
  IoIosDocument,
  FiPhone,
  PiGenderIntersex,
} from "../../assets/icons/vander";
import { FaAddressBook, FaHospital, FaCity } from "react-icons/fa";
import { useAuthStore } from "../../auth/hooks";

export const SecretaryProfile = () => {
  const { user } = useAuthStore();

  return (
    <div className="tab-pane fade show active">
      <h5 className="mb-1">Perfil</h5>
      <div className="row g-3">
        <div className="col-md-6">
          <div className="rounded shadow overflow-hidden text-break">
            <div className="list-unstyled p-4">
              <div className="d-flex align-items-center mt-0">
                <IoIosDocument className="align-text-bottom text-primary h5 mb-0 me-2" />
                <h6 className="mb-0">Documento</h6>
                <p className="text-muted mb-0 ms-2">{user.document}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="rounded shadow overflow-hidden text-break">
            <div className="list-unstyled p-4">
              <div className="d-flex align-items-center mt-0">
                <IoIosDocument className="align-text-bottom text-primary h5 mb-0 me-2" />
                <h6 className="mb-0">Tipo de documento</h6>
                <p className="text-muted mb-0 ms-2">
                  {user.documentType.description}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="rounded shadow overflow-hidden text-break">
            <div className="list-unstyled p-4">
              <div className="d-flex align-items-center mt-0">
                <FiUser className="align-text-bottom text-primary h5 mb-0 me-2" />
                <h6 className="mb-0">Nombres</h6>
                <p className="text-muted mb-0 ms-2">{user.firstName}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="rounded shadow overflow-hidden text-break">
            <div className="list-unstyled p-4">
              <div className="d-flex align-items-center mt-0">
                <FiUser className="align-text-bottom text-primary h5 mb-0 me-2" />
                <h6 className="mb-0">Apellidos</h6>
                <p className="text-muted mb-0 ms-2">{user.lastName}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="rounded shadow overflow-hidden text-break">
            <div className="list-unstyled p-4">
              <div className="d-flex align-items-center mt-0">
                <FiMail className="align-text-bottom text-primary h5 mb-0 me-2" />
                <h6 className="mb-0">Email</h6>
                <p className="text-muted mb-0 ms-2">{user.email}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="rounded shadow overflow-hidden text-break">
            <div className="list-unstyled p-4">
              <div className="d-flex align-items-center mt-0">
                <FiPhone className="align-text-bottom text-primary h5 mb-0 me-2" />
                <h6 className="mb-0">No. celular</h6>
                <p className="text-muted mb-0 ms-2">{user.phoneNumber}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="rounded shadow overflow-hidden text-break">
            <div className="list-unstyled p-4">
              <div className="d-flex align-items-center mt-0">
                <FiPhone className="align-text-bottom text-primary h5 mb-0 me-2" />
                <h6 className="mb-0">País celular</h6>
                <p className="text-muted mb-0 ms-2">{user.countryPhone.name}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-12">
          <hr />
        </div>
        <div className="col-md-12">
          <h5 className="mb-1">Dirección</h5>
        </div>

        <div className="col-md-6">
          <div className="rounded shadow overflow-hidden text-break">
            <div className="list-unstyled p-4">
              <div className="d-flex align-items-center mt-0">
                <FaAddressBook className="align-text-bottom text-primary h5 mb-0 me-2" />
                <h6 className="mb-0">País</h6>
                <p className="text-muted mb-0 ms-2">{user.country}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="rounded shadow overflow-hidden text-break">
            <div className="list-unstyled p-4">
              <div className="d-flex align-items-center mt-0">
                <FaAddressBook className="align-text-bottom text-primary h5 mb-0 me-2" />
                <h6 className="mb-0">Departamento</h6>
                <p className="text-muted mb-0 ms-2">{user.department}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="rounded shadow overflow-hidden text-break">
            <div className="list-unstyled p-4">
              <div className="d-flex align-items-center mt-0">
                <FaCity className="align-text-bottom text-primary h5 mb-0 me-2" />
                <h6 className="mb-0">Ciudad</h6>
                <p className="text-muted mb-0 ms-2">{user.city}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="rounded shadow overflow-hidden text-break">
            <div className="list-unstyled p-4">
              <div className="d-flex align-items-center mt-0">
                <FaCity className="align-text-bottom text-primary h5 mb-0 me-2" />
                <h6 className="mb-0">Dirección</h6>
                <p className="text-muted mb-0 ms-2">{user.address}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-12">
          <hr />
        </div>

        <div className="col-md-6">
          <div className="rounded shadow overflow-hidden text-break">
            <div className="list-unstyled p-4">
              <div className="d-flex align-items-center mt-0">
                <PiGenderIntersex className="align-text-bottom text-primary h5 mb-0 me-2" />
                <h6 className="mb-0">Genero</h6>
                <p className="text-muted mb-0 ms-2">{user.gender.name}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="rounded shadow overflow-hidden text-break">
            <div className="list-unstyled p-4">
              <div className="d-flex align-items-center mt-0">
                <FaHospital className="align-text-bottom text-primary h5 mb-0 me-2" />
                <h6 className="mb-0">Ips</h6>
                <p className="text-muted mb-0 ms-2">{user.ips.name}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
